import { useCallback } from 'react';
import { globalErrorResponse } from '../../../../shared/notification/actions';
import { apiChangeReserveReportSettings } from './apiChangeReserveReportSettings';

export const useChangeReserveReportSettings = () => {
    return useCallback((message: string) => {
        apiChangeReserveReportSettings(message).catch(error => globalErrorResponse(error));
    }, []);
};
